import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

import { useObservable } from '@lib/common';
import { sessionQuery } from '@lib/state';
import { ProfileRoutes } from 'app/profile';
import { ReservationRoutes } from 'app/reservation';
import { AccountRoutes, SignInPrompt } from 'app/account';
import { PrivacyPage } from 'app/privacy';
import { ContactPage } from 'app/contact';

import { NavLayout } from './layout';
import { AboutPage } from 'app/about';
import { GuestSurveyRoutes } from 'app/survey';
import { GuestReportRoutes } from 'app/report';
import { TermsPage } from 'app/terms';
import { FeedbackRoutes } from 'app/feedback';

export const AppRoutes: React.FC = () => {
  const isLoggedIn = useObservable(sessionQuery.isLoggedIn, 'async');

  return (
    <NavLayout>
      <SignInPrompt isLoggedIn={!!isLoggedIn} />
      <Switch>
        <Route path="/about" component={AboutPage} exact />
        <Route path="/privacy" component={PrivacyPage} exact />
        <Route path="/contact" component={ContactPage} exact />
        <Route path="/account" component={AccountRoutes} />
        <Route path="/survey" component={GuestSurveyRoutes} />
        <Route path="/report" component={GuestReportRoutes} />
        <Route path="/terms" component={TermsPage} exact />
        {isLoggedIn && <Route path="/profile" component={ProfileRoutes} />}
        {isLoggedIn && <Route path="/feedback" component={FeedbackRoutes} />}
        <Route
          path="/beta"
          exact
          component={({ location }: RouteComponentProps) => (
            /* handle the redirect case at /beta if we've already bypassed the landing page, preserving the query string */
            <Redirect
              to={{
                ...location,
                pathname: '/',
              }}
            />
          )}
        />
        <Route path="/" component={ReservationRoutes} />
        <Redirect to="/" />
      </Switch>
    </NavLayout>
  );
};
